import * as billing from "../api/billing/index";
import { updateNewRelicStatsFromSession } from "../util/util";
import { pendoTrack } from "../util/pendoUtil";

export function baseToArrayBufferConversion(baseValue) {
  const binaryString = window.atob(baseValue); // Comment this if not using base64
  const bytes = new Uint8Array(binaryString.length);
  return bytes.map((byte, i) => binaryString.charCodeAt(i));
}

export function blobFileCreator(body, filename, extension = "pdf") {
  const blob = new Blob([body]);
  const fileName = `${filename}.${extension}`;
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, fileName);
  } else {
    const link = document.createElement("a");
    // Browsers that support HTML5 download attribute
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      setTimeout(() => {
        link.click();
        document.body.removeChild(link);
      }, 1000);
    }
  }
}

export function printInvoice(invoiceNumber, sourceComponent, accountId) {
  updateNewRelicStatsFromSession();
  return billing.downloadPdfFileCall(invoiceNumber).then((response) => {
    const arrayBuffer = baseToArrayBufferConversion(response.data.data);
    const blob = new Blob([arrayBuffer], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    sourceComponent === "quickBillPendo"
      ? pendoTrack("Customer Portal | Billing And Payment | Quick Bill | View Invoice", {
          status: "Success",
          invoiceNumber: invoiceNumber,
          statusCode: response.data.statusCode,
          accountId: accountId,
        })
      : pendoTrack("Customer Portal | Billing And Payment | Billing History | View Invoice", {
          status: "Success",
          invoiceNumber: invoiceNumber,
          statusCode: response.data.statusCode,
          accountId: accountId,
        });
    return url;
  });
}

export function dateTwoYearsAgo() {
  return new Date(new Date().setFullYear(new Date().getFullYear() - 2)).toISOString().slice(0, 10);
}

export function dateToday() {
  return new Date().toISOString().slice(0, 10);
}

// spliting month from date
export function getMonthAndDate(monthData) {
  let month;
  let date;
  if (monthData) {
    month = monthData.toString().trim().substring(0, 3).toLowerCase();
    date = monthData.toString().trim().substring(3, monthData.toString().trim().length).split(",").join(", ");
    return [month, date];
  } else {
    return "";
  }
}
